import * as types from "../types";

export const nbfcLoginRequest = ({loginReq}) => ({
    type: types.NBFC_LOGIN_REQUEST,
    payload:{
        loginReq
    }
})

export const nbfcLoginSuccess = ({loginResult}) => ({
    type: types.NBFC_LOGIN_SUCCESS,
    payload:{
        loginResult
    }
})

export const nbfcLoginFailure = ({error}) => ({
    type: types.NBFC_LOGIN_FAILURE,
    payload:{
        error: error
    }
})

